module.exports = __webpack_public_path__ + "media/img/super-venue/badge-card-supervenue-4102ab8fffb4cda91f8dd3ad3360e552.svg";